import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  styled,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DATE_FORMATS, useDateFormat } from '../../context/DateFormatContext';

// RTL-aware FormControl
const RTLFormControl = styled(FormControl)(({ theme, isRtl }) => ({
  ...(isRtl && {
    '& .MuiInputLabel-root': {
      right: 30,
      left: 'auto',
      transformOrigin: 'top right',
      paddingRight: '8px',
      paddingLeft: '4px',
      position: 'absolute',
      top: 0,
      zIndex: 1,
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(0, -9px) scale(0.75)',
      paddingRight: '8px',
      paddingLeft: '4px',
    },
    '& .MuiInputBase-input': {
      textAlign: 'right',
      direction: 'rtl',
    },
    '& .MuiSelect-select': {
      paddingRight: '32px',
      textAlign: 'right',
      paddingLeft: '32px',
    },
    '& .MuiSelect-icon': {
      right: 'auto',
      left: 7,
      pointerEvents: 'none',
      color: theme.palette.action.active,
    },
  }),
}));

/**
 * Calendar selector component - allows users to choose between Shamsi, Qamari, and Gregorian calendars
 */
const CalendarSelector = ({ size = 'small', sx = {} }) => {
  const { t, i18n } = useTranslation(['calendar']);
  const isRtl = i18n.language === 'dari' || i18n.language === 'ps';
  const { dateFormat, setDateFormat } = useDateFormat();

  const handleChange = (event) => {
    setDateFormat(event.target.value);
  };

  return (
    <Box sx={{ minWidth: 150, ...sx }}>
      <RTLFormControl 
        fullWidth
        size={size}
        isRtl={isRtl}
        sx={{
          '& .MuiInputLabel-root': {
            ...(isRtl && {
              right: '30px !important',
              textAlign: 'right',
            }),
          }
        }}
      >
        <InputLabel id="calendar-format-label">{t('calendar:calendar_format')}</InputLabel>
        <Select
          labelId="calendar-format-label"
          id="calendar-format-select"
          value={dateFormat}
          label={t('calendar:calendar_format')}
          onChange={handleChange}
          MenuProps={{
            disableScrollLock: true,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: isRtl ? 'right' : 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: isRtl ? 'right' : 'left',
            },
            PaperProps: {
              style: {
                direction: isRtl ? 'rtl' : 'ltr',
              },
            },
          }}
        >
          <MenuItem value={DATE_FORMATS.SHAMSI}>{t('calendar:shamsi')}</MenuItem>
          <MenuItem value={DATE_FORMATS.QAMARI}>{t('calendar:qamari')}</MenuItem>
          <MenuItem value={DATE_FORMATS.GREGORIAN}>{t('calendar:gregorian')}</MenuItem>
        </Select>
      </RTLFormControl>
    </Box>
  );
};

export default CalendarSelector; 